// extracted by mini-css-extract-plugin
export default {"question":"TextQuestion_question__ffghh","title":"TextQuestion_title__pPvrR","optional":"TextQuestion_optional__5FYT+","text":"TextQuestion_text__Nw82d"};